import 'idempotent-babel-polyfill';
import Vue from 'vue';
import VueHighcharts from 'vue-highcharts';
import Vuelidate from 'vuelidate';
import Vue2TouchEvents from 'vue2-touch-events';
import moment from 'moment';
import 'moment/locale/de';
import store from './store/store';
import apiConfig from './api/config';
import merge from 'lodash.merge';
import { setApiConfig } from './api/apiRequest';

Vue.config.productionTip = false;
Vue.use(VueHighcharts);
Vue.use(Vuelidate);
Vue.use(Vue2TouchEvents);

moment.locale('de');

const elements = document.querySelectorAll('[data-app]');
const configs = [];

/* global __CURRENT_APP, __CURRENT_THEME */
const currentApp = require('./apps/' + __CURRENT_APP + '/' + __CURRENT_THEME + '.vue');
require('./assets/scss/vkb_2mk05_' + __CURRENT_APP + '_' + __CURRENT_THEME + '.scss');

for (const element of elements) {
  try {
    const config = JSON.parse(element.attributes['data-app'].value);
    let appConfig;
    try {
      appConfig = JSON.parse(element.attributes['data-config'].value);
    } catch (err) {

    }
    if (config) {
      configs.push(merge({}, apiConfig[__CURRENT_APP], config, appConfig, { theme: __CURRENT_THEME.toLowerCase() }));

      // init axios here
      setApiConfig(configs[configs.length - 1]);
      store.state.appConfigs = [...configs];
      new Vue(Vue.util.extend({ store, configIndex: configs.length - 1 }, currentApp.default)).$mount(element);
    }
  } catch (error) {
    console.log('error', error);
  }
}



// WEBPACK FOOTER //
// ./src/main.js